import styled, { css } from "styled-components";

import { theme } from "@/components/bild/theme";
import { colors } from "@/styles/Variants";

const color = colors.bild;
const { breakpoint } = theme;

export const RadioWrapper = styled.label`
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  user-select: none;
`;

export const HiddenRadio = styled.input.attrs({ type: "radio" })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

export const RadioIndicator = styled.span<{ $selected: boolean }>`
  position: relative;
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid ${color.vader300};
  background-color: transparent;
  transition: all 200ms;
  margin-right: 7px;
  margin-top: 2px;
  margin-bottom: 2px;
  ${({ $selected }) =>
    $selected &&
    css`
      border-color: ${color.red500};

      &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: ${color.red500};
      }
    `}
`;

export const LabelText = styled.span`
  max-width: calc(100% - 27px);
  word-wrap: break-word;
  align-self: center;
  font-size: 18px;
  color: ${color.vader500};

  @media ${breakpoint.medium} {
    font-size: 16px;
  }
  @media ${breakpoint.small} {
    font-size: 16px;
  }
`;
